import { emptyQuoteEngineCalculation } from './quoteEngineContract';
import { financialTotals } from './quoteFinancialPresentation';

export const recordedQuoteCalculation = (editor) => {
  const stored = editor.recordedFinancialPresentation;
  const base = emptyQuoteEngineCalculation(editor);
  const byId = new Map((stored?.lines || []).map((line) => [String(line.id), line]));
  const lines = base.lines.map((line) => ({ ...line, ...(byId.get(String(line.id)) || {}) }));
  const visible = lines.filter((line) => line.isClientVisible !== false);
  return { ...base, source: 'recorded',
    totals: stored?.totals || financialTotals(editor.serverCalculation?.totals),
    taxBreakdown: stored?.taxBreakdown || [],
    taxCalculationMethod: stored?.taxCalculationMethod || null,
    taxAllocationMethod: stored?.taxAllocationMethod || null,
    sectionTotals: stored?.sectionTotals || [],
    optionTotalsUnavailable: Boolean(editor.options?.length && !stored?.optionViews?.length),
    optionViews: (stored?.optionViews || []).map((option) => {
      const input = (editor.options || []).find((item) => String(item.id) === String(option.id));
      const inputs = (input?.sections || []).flatMap((section) => section.lines || []);
      return { ...option, lines: option.lines.filter((line) => inputs.find((item) => String(item.id) === String(line.id))?.isClientVisible !== false) };
    }),
    lines, internalLines: lines, clientLines: visible, visibleLines: visible,
  };
};
